import type { Expert, ExpertPaper } from "../types";

/** Only http(s) links from the API are rendered. */
const safe = (url: string | null | undefined): string | null =>
  url && /^https?:\/\//i.test(url) ? url : null;

export const paperUrl = (p: ExpertPaper): string | null =>
  safe(p.url) ??
  (p.doi ? `https://doi.org/${p.doi}` : p.pmid ? `https://pubmed.ncbi.nlm.nih.gov/${p.pmid}/` : null);

/** ORCID profile, else the OpenAlex author page, else nothing. */
export const profileUrl = (e: Expert): string | null =>
  safe(e.orcid) ?? (e.openalex_ids[0] ? `https://openalex.org/${e.openalex_ids[0]}` : null);
